<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>money</md-icon>
          </div>
          <h4 class="title">Wingio Product Prices</h4>
        </md-card-header>

        <md-card-content>
            <h3 class="product-title" v-if="produtDetail">{{ produtDetail.name }}</h3>
            <md-table v-model="productPrices" table-header-color="green">
                <!-- Table Headers -->
                <md-table-row slot="md-table-head">
                    <md-table-head>Price</md-table-head>
                    <md-table-head>Label</md-table-head>
                    <md-table-head>Is Active</md-table-head>
                </md-table-row>

                <!-- Table Rows -->
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="Price">
                    {{ getCurrencySymbol(item.stripePriceDetail.currency) }} {{ item.price }}
                    </md-table-cell>
                    <md-table-cell md-label="Label">
                    {{ item.label }}
                    </md-table-cell>

                    <md-table-cell md-label="Is Active">
                    <md-checkbox v-model="item.isActive" @change="onDefaultChange(item)">
                        <!-- Optional: label inside checkbox -->
                    </md-checkbox>
                    </md-table-cell>
                </md-table-row>
            </md-table>
            
            <md-divider class="md-layout-item md-size-100 md-layout md-gutter"></md-divider>
                <!-- New Price Form -->
                <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-20">
                    <md-field>
                    <label>New Price</label>
                    <md-input v-model="newPriceForm.price" type="number" min="0" step="0.01"></md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-30">
                    <md-field>
                    <label>Label</label>
                    <md-input v-model="newPriceForm.label" type="text"></md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-10 md-align-center">
                    <md-checkbox v-model="newPriceForm.isActive">Is Active</md-checkbox>
                </div>

                <div class="md-layout-item md-size-20 md-align-center">
                    <md-button class="md-raised md-primary" @click="addNewPrice()" :disabled="isDisabled">
                        Add Price <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                    </md-button>
                </div>
                </div>

        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import OrdersDataService from "../../services/SuperAdmin/Kids/OrdersDataService";

export default {
  components: {
    
  },
  data() {
    return {
        isDisabled: false,
        productdId: this.$route.query.id,
        productPrices: [],
        produtDetail: null,
        newPriceForm: {
          price: null,
          isDefault: false,
          offerPrice: null,
          offerPriceText: null,
          recurringInterval: ""
        },
    };
  },
  methods: {
    getWingioProductShippingPrices() {
        OrdersDataService.getWingioProductShippingPrices({ id: this.productdId })
          .then((response) => {
            this.productPrices = response.data.data;
            this.produtDetail = response.data.produtDetail
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    
    getCurrencySymbol(currency) {
        const map = {
        usd: '$',
        eur: '€',
        gbp: '£',
        inr: '₹',
        jpy: '¥',
        aud: 'A$',
        cad: 'C$',
        cny: '¥',
        krw: '₩',
        };
        return map[currency?.toLowerCase()] || currency.toUpperCase();
    },
    addNewPrice() {
        const { price, label, isActive } = this.newPriceForm;

        if (!price || price <= 0) {
            this.$toast.error("Enter a valid price.");
            return;
        }
        this.isDisabled = true;
        let data = {
            price: price,
            label: label,
            productdId: this.productdId,
            isActive: isActive,
        }
        OrdersDataService.addNewShippingPrice(data)
          .then((response) => {
            this.isDisabled = false;
            this.newPriceForm = {
                price: null,
                isActive: false,
                label: null,
            };
            this.$toast.success(response.data.respones_msg);
            this.getWingioProductShippingPrices();
          })
          .catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    onDefaultChange(item) {
      if (item.isDefault == false) {
        this.$toast.error("Please set at least one default price.");
        item.isDefault = true;
        return;
      }
      let data = { productdPriceId: item._id, isActive: item.isActive }
      OrdersDataService.toggleActiveShippingPrice(data)
          .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.getWingioProductShippingPrices();
          })
          .catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
          });
    }
  },
  watch: {
  },
  beforeMount() {
    this.getWingioProductShippingPrices()
  },
};
</script>